import React, { useContext, useEffect, useState } from "react";
import backgroundImage from "./themeimg/dtLite/page_bg_image.jpg"
import headerImg from "./themeimg/dtLite/dream_travel_logo.png"
import banner from "./themeimg/dtLite/subscription_banner3-min.jpg"
import { baseUrl, data, getHeaders } from '../config/config';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import { SendGuiDataEvents } from "../CommonScript";
import LoaderComponent from './Loader';
import { Context } from "../Context/Context";
import SubsModal from "./SubsModal";
import icon from "../components/themeimg/dtLite/thank_you_icon.png"
import circle from "./themeimg/dtLite/circle.png"
import check from "./themeimg/dtLite/checkcircle.png"



const Subscription = ({packSin, packBanner})=>{

    const msisdn = localStorage.getItem("msisdn") ? localStorage.getItem("msisdn") : localStorage.getItem("msisdn2")
    const navigate = useNavigate()
    const lang = localStorage.getItem("lang") || "fr"
    const [scriptLoaded,setScriptLoaded] = useState(false)
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [loading,setLoading] = useState(false)
    const [tid,setTid] = useState("")
    const [modal,setModal] = useState(false)
    const location = useLocation()
    const { packText } = location.state || {};
    const { title } = location.state || {};
    const { subTitle } = location.state || {};
    const { btn } = location.state || {};

    const camp = localStorage.getItem("camp")
    const rcid = localStorage.getItem("rcid")
    const pack = localStorage.getItem("packType")
    const type = sessionStorage.getItem("type") || localStorage.getItem("type")

    console.log("modal",modal)

    const {pageLoader , handlePageLoader, changeErrorState,setPageLoader} = useContext(Context)

    const Callback = () => {
      let guiEvents={};
    guiEvents['page']="subscription";
    guiEvents["event"] = "ad_campaign_click";
    guiEvents["opco"] = "mtn_cmr_dt";
    guiEvents["camp"] = camp;
    guiEvents["rcid"] = rcid;
    guiEvents["ua"] = "mobile agent"
    SendGuiDataEvents(guiEvents);
        console.log("callback called")
        const url = "https://camp-reports.bngrenew.com:5455/digitalservice/api/sendcallback"
        const headers={
             ...getHeaders(),
            "Content-Type":"application/json"
        }
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 'camp': camp, 'rcid': rcid, "opco": "mtn_cmr_dt", "ua": "mobile agent", "msisdn": msisdn, affId : camp === "MTNCMRTHPR" ? "thirdparty" : "bng_offer18"}),
            headers: headers
        })
            .then(res => {
              console.log("response",res)
                if(res.ok === true){
                    localStorage.removeItem("camp")
                    localStorage.removeItem("rcid")
                }
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
               if(result === "ok"){
                // checksub()
                localStorage.removeItem("camp")
                localStorage.removeItem("rcId")
               }
            },
                (error) => {
                    console.log('error:::', error)
                })
    }

     const clickAction = ()=>{
        if(!sessionStorage.getItem("noevina")){
        hitTransCheck()
        }
        else{
         Subscribe(msisdn)
        }
      }
    

    const ProtectedScript =() =>{
      handlePageLoader(true);
  
      if (document.getElementById("dcbProtect")) {
        console.log("DCBProtect script is already loaded");
        setScriptLoaded(true);
        handlePageLoader(false);
        return;
      }
  
      axios({
        method: 'post',
        url: baseUrl + "dcbScript",
        headers: getHeaders(),
      }).then((resp) => {
        console.log('response', resp.data);
        if(resp.data.status === "success"){
          // hitTransCheck(resp.data.tid)
          setTid(resp.data.tid)
          setIsButtonDisabled(false);
        }
  
        const scriptContent = resp.data.script;
        if (scriptContent) {
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.text = scriptContent;
          script.id = "dcbProtect";
          document.body.appendChild(script);
          setScriptLoaded(true);
          setIsButtonDisabled(false);
  
          // Directly check for cta_button without relying on DOMContentLoaded
          const ctaButton = document.getElementById('cta_button');
          document.getElementById('cta_button').disabled = false;
          if (ctaButton) {
            console.log("cta_button is ready");
            const ev = new Event('DCBProtectRun');
            document.dispatchEvent(ev);
          } else {
            console.error("cta_button not found in DOM.");
          }
        } else {
          console.error("DCBProtect script content is empty");
        }
  
        let transactionID = resp.data.transaction_identify;
        localStorage.setItem("transactionID", transactionID);
  
        if (resp.data.status !== "success") {
          navigate('/thanks', {
            state: { message: resp?.data?.message }
          });
        }
  
      }).catch((error) => {
        console.log("error -----> ", error);
      }).finally(() => {
        handlePageLoader(false);
      });
    }

    
  

      const hitTransCheck=()=>{
        handlePageLoader(true)
          axios({
             method:"post",
             url: baseUrl + 'transCheck',
             data: JSON.stringify({ tid: tid,msisdn:msisdn }),
             headers:getHeaders()
          }).then((resp)=>{
            if(resp.data.status === "success"){
                Subscribe(msisdn)
            }
            else{
                navigate('/thanks', {
                    state: { message: resp.data.message}
                  });
            }
            handlePageLoader(false)
          }
        )
      }

      const hitTransaction=(transId,subId)=>{
        setLoading(true)
          axios({
             method:"post",
             url: baseUrl + 'transaction',
             data: JSON.stringify({ transactionId: transId,Packtype:type == 4 || type == 5 || type == 6 ? packSin :pack,tid: tid
              // subServiceId: subId, tid: tid
             }),
             headers:getHeaders()
          }).then((resp)=>{
            if(resp.data.status === "success"){
                navigate("/home")
            }
            else{
                navigate('/thanks', {
                    state: { message: resp.data.message}
                  });
                  setLoading(false)
            }
            
          }
        )
      }

    const Subscribe = async (msisdn) => {
      
        setLoading(true)
        try {
          const resp = await axios({
            method: 'post',
            url: baseUrl + 'subscribe',
            data: { msisdn: msisdn, Packtype: type == 4 || type == 5 || type == 6 ? packSin :pack },
            headers: getHeaders(),
          });

          setModal(true)
      
          const currentStatus = resp.data.subStatus;

          if (camp === 'C2CSMPMSC2C') {
          const sendTo = 'AW-16584996091/MhBFCPiGwcoaEPvpq-Q9';
          const CONVERSION_FLAG = "google_conversion_fired";
        
          // Prevent firing more than once
          if (!sessionStorage.getItem(CONVERSION_FLAG)) {
            function fireConversion() {
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'conversion', { send_to: sendTo });
                sessionStorage.setItem(CONVERSION_FLAG, 'true'); 
              } else {
                setTimeout(fireConversion, 300);
              }
            }
        
            if (!document.getElementById('google-ads-base')) {
              const gTagScript = document.createElement('script');
              gTagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16584996091';
              gTagScript.async = true;
              gTagScript.id = 'google-ads-base';
              document.head.appendChild(gTagScript);
        
              const configScript = document.createElement('script');
              configScript.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', ''AW-16584996091');
              `;
              document.head.appendChild(configScript);
        
              setTimeout(fireConversion, 1000);
            } else {
              fireConversion();
            }
          } else {
            console.log("Conversion already fired — skipping.");
          }
        }
    
          if (resp.data.status !== '' && resp.data.status !== undefined) {
            if (resp.data.status === 'failed') {
                // navigate('/thanks', {
                //     state: { message: resp?.data?.message,error:"technical",title:resp?.data?.title }
                //   });

                setTimeout(() => {
                    
                    
                    
                    checkSubHandler();  
                }, 5000); 
            }
            else if (resp.data.status === 'success') {
              if (currentStatus === 'active') {
                  let guiEvents = {
                      page: "subscription",
                      status: currentStatus,
                      event: "subscribed_user"
                  };
                  await SendGuiDataEvents(guiEvents);
                  
                  const Subscribe = async (msisdn) => {
        setLoading(true)
        try {
          const resp = await axios({
            method: 'post',
            url: baseUrl + 'subscribe',
            data: { msisdn: msisdn, Packtype:pack },
            headers: getHeaders(),
          });
      
          const currentStatus = resp.data.subStatus;
          if (resp.data.status !== '' && resp.data.status !== undefined) {
            if (resp.data.status === 'failed') {
                // navigate('/thanks', {
                //     state: { message: resp?.data?.message,error:"technical",title:resp?.data?.title }
                //   });

                setTimeout(() => {
                    setLoading(false); 
                    
                    
                    checkSubHandler();  
                }, 5000); 
            }
            else if (resp.data.status === 'success') {
              if (currentStatus === 'active') {
                  let guiEvents = {
                      page: "subscription",
                      status: currentStatus,
                      event: "subscribed_user"
                  };
                  await SendGuiDataEvents(guiEvents);
                  setLoading(false)
                  setTimeout(() => {
                    setLoading(false); 
                    
                    
                    checkSubHandler();  
                }, 5000); 

                  //if (camp && rcid && camp!== "C2COFRCMCPA") {
                      //Callback();
                  // } 
              } else if (currentStatus === 'pending') { 
                console.log("Loader started:", loading); 
                
                setTimeout(() => {
                    setLoading(false); 
                    
                    
                    checkSubHandler();  
                }, 5000);

                 
                  //if (camp && rcid && camp!== "C2COFRCMCPA") {
                      //Callback();
                  //} 
              } else {
                 
                  // navigate('/thanks', {
                  //     state: { message: resp?.data?.message }
                  // });

                  setTimeout(() => {
                    setLoading(false); 
                    
                    
                    checkSubHandler();  
                }, 5000); 
              }
          }
           
          }
          
        } catch (error) {
          console.error('An error occurred while checksub:', error);
        }
        
        
      }

                  setTimeout(() => {
                    setLoading(false); 
                    
                    
                    checkSubHandler();  
                }, 5000); 

                  //if (camp && rcid && camp!== "C2COFRCMCPA") {
                  //   Callback();
                  //} 
              } else if (currentStatus === 'pending') {
                setLoading(true); 
                console.log("Loader started:", loading); 
                
                setTimeout(() => {
                    setLoading(false); 
                    
                    
                    checkSubHandler();  
                }, 5000);

                 
                  //if (camp && rcid && camp!== "C2COFRCMCPA") {
                   //   Callback();
                  //} 
              } else {
                 
                  // navigate('/thanks', {
                  //     state: { message: resp?.data?.message }
                  // });

                  setTimeout(() => {
                     
                    
                    
                    checkSubHandler();  
                }, 5000); 
              }
          }
           
          }
          
        } catch (error) {
          console.error('An error occurred while checksub:', error);
        }
        
        
      }


      
      const checkSubHandler = async () => {
        setLoading(true)
        try {
          const resp = await axios({
            method: 'post',
            url: baseUrl + 'checkSub',
            data: {msisdn:msisdn},
            headers: getHeaders(),
          });
      
          const currentStatus = resp.data.subStatus;
          console.log("response",resp.data)
          if (resp.data.status !== '' && resp.data.status !== undefined) {
            if (resp.data.status === 'failed') {
              navigate('/thanks', {
                state: { message: resp?.data?.message}
              });
            } else if (resp.data.status === 'success') {
               if (resp.data.subStatus === 'active') {
                if(!sessionStorage.getItem("noevina")){
                  hitTransaction(resp.data.transactionId, resp.data.subServiceId);
                }
                else{
                  navigate("/home")
                }
                
              } 
              else{
                navigate('/thanks', {
                    state: { message: resp?.data?.message, hitchecksub:true}
                  });
            }
            }
            else{
                navigate('/thanks', {
                    state: { message: resp?.data?.message}
                  });
            }
            setLoading(false)
          }
      
          
          localStorage.setItem("subStatus", resp.data.subStatus);
        } catch (error) {
          console.error('An error occurred while checksub:', error);
        }
      }

      useEffect(()=>{
        if(!sessionStorage.getItem("noevina")){
            ProtectedScript()
        }
        else{
          setIsButtonDisabled(false)
        }
      },[])

     
  const [vh, setVh] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => setVh(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

      
    return(
        <div className="max-w-[500px] mx-auto min-h-[100vh] pb-2 bg-[#FFCC00]" 
             >
                {(pageLoader || loading) && <LoaderComponent />}
                
                 {modal && <SubsModal title={"Votre demande a été soumise, vous recevrez bientôt la notification par SMS."} icon={icon}/>}
  
        {
          type == 4 || type == 5 || type == 6 ?
            <div
              id="cta_button"
              onClick={!isButtonDisabled ? clickAction : undefined}
              style={{
                position: "relative",
                width: "100vw",
                height: `${vh}px`, // actual device height
                cursor: isButtonDisabled ? "not-allowed" : "pointer",
                overflow: "hidden",
              }}
            >
              {console.log(":::baner:::::", packBanner)}
              <img
              src={packBanner}
              alt="cta"
              style={{
                opacity: isButtonDisabled ? 0.5 : 1,
                width: "100%",
                height: "100%", 
                display: "block",
              }}
            />
          </div>

          : <>
            <div><img className="w-[65%] pt-2 mx-auto" src={headerImg} alt="header" /></div>
            <div className="theme-bg bg-cover bg-no-repeat">
                <div className="w-full mt-6 bg-[#FFCC00] relative">
                    <img src={banner} className="h-[50vh] w-[100%] mx-auto "></img>
                    <div className="absolute bottom-24 w-full text-center text-white text-2xl">

                      {lang === "fr" ? "Bienvenue à Dream Travel" : "Welcome to Dream Travel"}
                    </div>
                    <div className="absolute bottom-8 sm:bottom-10 w-full text-center text-white text-3xl font-extrabold">
                    {lang === "fr" ? "vers une destination exotique" : "Mega Contest to an exotic destination"}
                    </div>
                </div>
                <div className="w-[80%]  text-black text-xl ml-8 mt-10 tracking-wide font-extrabold">
                  {lang === "fr" ? "Veuillez confirmer pour vous abonner" : "Please confirm to subscribe"}
                </div>
                <div className="w-[80%]  text-black ml-8  mt-6 tracking-wide font-extrabold">
                {/* {lang === "fr" ? "Pack journalier - 100 frs" : "Daily Pack - 100 Frs"}  */}
                {/* {packText} */}
                </div>
                {/* <div className="w-[80%]  text-black ml-8 mt-2 tracking-wide text-sm">
                {lang === "fr" ? "*Des micro-frais peuvent s'appliquer" : "*Micro Changes may apply"}
                </div> */}

                {packText && packText?.pack_type.map((item)=>{
          return(
            <div key={item.id} className="border-2 border-black w-[80%] mx-auto py-2 text-black ml-8 tracking-wide font-extrabold mt-4 flex rounded-md justify-between px-1">
              {item.price}
              <img src={pack === item.pack ? check : circle} className="w-6 h-6"></img>
            </div>
          )
        })}


                <div className="mt-10 flex">
                    <button className={ ` ${isButtonDisabled ? "opacity-15" : ""} border-1 text-[#FFCC00] bg-black font-thin rounded-2xl w-[80%] justify-center mx-auto p-2`} id="cta_button" onClick={clickAction} 
                    // onClick={() => Subscribe(msisdn)}
             disabled={isButtonDisabled}>{lang === "fr" ? "Confirmer" : "Confirm"}</button>
                </div>
            </div>
          </>
      }
        </div>
    )
}

export default Subscription
